import compose from 'recompose/compose'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { WithAnimation, WithForwardRef } from 'aria-viewer/common'
import MobileRegistrationForm from '../components/mobileRegistrationForm'

export default compose(
    WithForwardRef,
    connect(
        mapSelectorsToProps(['viewportHeight']),
        null
    ),
    WithAnimation({
        style: {
            zIndex: 20000,
        },

        show: ({ areRegistrationModalsOpen, isWelcomePage, desktop }) => {
            return !isWelcomePage && !desktop && areRegistrationModalsOpen
        },

        start: ({ viewportHeight }) => ({
            top: `${viewportHeight / 2}px`,
            opacity: 0,
        }),

        enter: {
            top: ['0px'],
            opacity: [1],
            timing: { duration: 300 },
        },

        update: {
            top: ['0px'],
            opacity: [1],
            timing: { duration: 300 },
        },

        leave: ({ viewportHeight }) => ({
            top: [`${viewportHeight / 2}px`],
            opacity: [0],
            timing: { duration: 300 },
        }),
    })
)(MobileRegistrationForm)
